import MmenuLight from 'mmenu-light'

document.addEventListener('DOMContentLoaded', () => {
    /*
     * Responsive menu (mmenu-light plugin)
     */

    const menu = new MmenuLight(
        document.querySelector('#my-menu'),
        '(max-width: 1200px)'
    )

    menu.navigation({
        title: '',
    })

    const drawer = menu.offcanvas({
        position: 'right',
        top: '80',
    })

    const burgerIcon = document.querySelector("a[href='#my-menu']")
    const secondaryMenu = document.querySelector('.c-secondaryNav')

    burgerIcon.addEventListener('click', (evnt) => {
        evnt.preventDefault()

        if (!burgerIcon.classList.contains('--navOpen')) {
            drawer.open()
            burgerIcon.classList.add('--navOpen')
            secondaryMenu.classList.add('--navOpen')
        } else {
            drawer.close()
            burgerIcon.classList.remove('--navOpen')
            secondaryMenu.classList.remove('--navOpen')
        }
    })
})
